import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { usePagesTranslation } from "../../locales";
import DataDeletionFormLayout from "./DataDeletionFormLayout";

function DataDeletionVerifiedMain() {
    const { t } = usePagesTranslation();
    const navigate = useNavigate();

    return (
        <DataDeletionFormLayout>
            <Typography
                variant="h4"
                gutterBottom
                sx={{ fontWeight: 600, mb: 3, color: "#3BA666" }}
            >
                {t("core.legal.dataDeletionVerified.title")}
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                {t("core.legal.dataDeletionVerified.message")}
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
                {t("core.legal.dataDeletionVerified.details")}
            </Typography>
            <Box sx={{ mt: 3 }}>
                <Button
                    variant="contained"
                    onClick={() => navigate("/")}
                    sx={{
                        backgroundColor: "#3BA666",
                        textTransform: "none",
                        fontWeight: 600,
                        px: 4,
                        py: 1.5,
                        "&:hover": {
                            backgroundColor: "#2E8B57",
                        },
                    }}
                >
                    {t("core.legal.dataDeletionVerified.home")}
                </Button>
            </Box>
        </DataDeletionFormLayout>
    );
}

export default DataDeletionVerifiedMain;
